import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  total: 0,
  error: "",
  message: "",
};

export const singleUserWithdrawAction = createAsyncThunk(
  "single-user-withdraw-transaction",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `/admins/api/single-user-widthdrawal-transaction?p_user_id=${data?.p_user_id}&startDate=${data?.startDate}&endDate=${data?.endDate}&publisher_id=${data?.publisher_id}&page=${data?.page}&limit=${data?.limit}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const singleUserWidthdrawSlice = createSlice({
  name: "single-user-withdraw-transaction",
  initialState,
  reducers: {
    resetData: (state) => {
      state.status = null;
      state.loading = false;
      state.data = [];
      state.total = 0;
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(singleUserWithdrawAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(singleUserWithdrawAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.total = action?.payload?.total;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(singleUserWithdrawAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetData } = singleUserWidthdrawSlice.actions;

export const singleUserWidthdrawTransactionReducer = singleUserWidthdrawSlice.reducer;
